<div fxLayout="row" fxLayoutAlign="center center" class="h-100">
    <div fxFlex="80" fxFlex.gt-sm="30" fxFlex.sm="60">
        <mat-card class="p-0 mat-elevation-z6 box">
            <div fxLayout="column" fxLayoutAlign="center center" class="bg-primary box-header">
                <mat-icon class="mat-icon-xlg">error</mat-icon>
                <h1 class="error">404</h1>
            </div>
            <mat-card-content fxLayout="column" fxLayoutAlign="end center" class="box-content">
                <div class="box-footer" >
                    <button class="btn btn-primary" style="cursor:pointer" class="mat-elevation-z8" type="button" (click)="goHome()">
                        <mat-icon>home</mat-icon>
                    </button>
                </div>
            </mat-card-content>
        </mat-card>          
    </div>
</div>